import ApiSignals, { ApiSignalFetchers, BusinessSignals } from "@/apis/api_signals"
import { getAssetsUrlWithHttp, resolveAssetImage } from "@/utils/common"
import { createLogger } from "@/utils/logger"
import { computed } from "@preact/signals"

const logger = createLogger("")

async function fetchUserInfo() {
    await ApiSignalFetchers.fetchDataSignalProfile()
}

const userInfo = computed(() => {
    return ApiSignals.dataSignalProfile.value
})

const avatar = computed(() => {
    return userInfo.value?.avatar
        ? getAssetsUrlWithHttp(userInfo.value?.avatar)
        : resolveAssetImage("pages/AccountPage/filbet_avatar.webp")
})

const clearUserInfo = () => {
    ApiSignals.dataSignalProfile.value = undefined
}

const isLogin = computed(() => {
    return BusinessSignals.isUserLogin.value
})

const UserInfo = {
    avatar,
    clearUserInfo,
    fetchUserInfo,
    isLogin,
    userInfo,
}

export default UserInfo
